module.exports = __webpack_public_path__ + "static/masternode-5e9a67d80cc270564ba41fce017ef4fa.svg";